import { useTranslation } from "react-i18next";

import Button, {
    BUTTON_COLORS,
    BUTTON_SIZES,
    BUTTON_VARIANTS
} from "components/DesignComponents/Button";
import {
    TOOLTIP_PLACEMENT,
    TooltipGeneral
} from "components/DesignComponents/Tooltips";
import { usePermissions } from "shared";

import { RENDER_NAMES, TokenListButtonsProps } from "../types";

const TokenListButtons = ({
    changeRenderName,
    close
}: TokenListButtonsProps) => {
    const { t } = useTranslation();

    const {
        isCreateTokenNotAllowed,
        PERMISSIONS,
        getNoPermissionTooltipTitle
    } = usePermissions();

    return (
        <>
            <Button
                fullWidth
                color={BUTTON_COLORS.Secondary}
                size={BUTTON_SIZES.Normal}
                variant={BUTTON_VARIANTS.TextOnly}
                onClick={close}
            >
                {t("Button##close")}
            </Button>

            <TooltipGeneral
                placement={TOOLTIP_PLACEMENT.Top}
                title={getNoPermissionTooltipTitle(PERMISSIONS.TokenCreate)}
            >
                <span>
                    <Button
                        fullWidth
                        color={BUTTON_COLORS.Primary}
                        size={BUTTON_SIZES.Normal}
                        variant={BUTTON_VARIANTS.TextOnly}
                        disabled={isCreateTokenNotAllowed}
                        onClick={() => changeRenderName(RENDER_NAMES.Generate)}
                    >
                        {t("Api tokens##add token")}
                    </Button>
                </span>
            </TooltipGeneral>
        </>
    );
};

export default TokenListButtons;
